module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/step3-full-4bc6a731d6d21b082032543055d1a73b.jpg";